import React from "react";
import { Headings } from "@arctheme-components/elements/Headings/Headings";
import { Paragraph } from "@arctheme-components/elements/Paragraph/Paragraph";
import { ProductTile } from "../../../ecommerce/Product/ProductTile";
import ListProductsCTA from "../ListProductsCTA/ListProductsCTA";
import useMobileBreakpoint from "@arctheme-hooks/useMobileBreakpoint";

export default function ListProductsGrid({ products, settings }) {
  const { section, mobile_breakpoint } = settings;
  // console.log('Product List (Grid) -  Settings', settings);
  const isMobile = useMobileBreakpoint(mobile_breakpoint);
  let ctaPosition = "top";

    settings.show_price = section.product_tile_price_show;
    settings.show_quickadd = section.product_tile_quickadd_show;
    settings.show_tags = section.product_tile_tag_show;

  if (isMobile) {
    ctaPosition = "bottom";
  }

  if (products.length <= 0) {
    return false;
  }

  return (
    <div className="product-list">
      <div className={"section-top"}>
        <div className={"section-bar w-full flex flex-row justify-between"}>
          <div className={"section-info"}>
            <Headings text={section?.title} type={section?.header_style} />
            <Paragraph text={section?.subtext} type={section?.subtext_style} />
          </div>
          {ctaPosition === "top" && (
            <ListProductsCTA section={section} isMobile={isMobile} />
          )}
        </div>
      </div>

      <div className={"w-full"}>
        <div className="row-start-1 col-start-1">
          <div className="carousel-item-container w-full">
            <div className="product-list__grid grid grid-cols-2 lg:grid-cols-4 gap-[8px] lg:gap-[24px] w-full">
              {products.map((product, id) => (
                <div key={id} className="grid-item">
                  <ProductTile
                    product={product}
                    swatches={product?.swatches}
                    siblings={undefined}
                    settings={settings}
                    enableWishlist={section.product_tile_wishlist_show}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className={"section-bottom flex justify-center mt-4"}>
        {ctaPosition === "bottom" && (
          <ListProductsCTA section={section} isMobile={isMobile} />
        )}
      </div>
    </div>
  );
}
